import React from 'react';
import './AuthVerifyScreen.css';

/**
 * AuthVerifyScreen — หน้าตรวจสอบสิทธิ์
 * Card เดียว เปลี่ยนแค่ text
 */
const AuthVerifyScreen = ({
  message = 'กำลังตรวจสอบสิทธิ์การเข้าใช้งาน',
  subMessage = 'กรุณารอสักครู่...',
}) => (
  <div className="avs">
    <div className="avs-card">
      {/* Spinner */}
      <div className="avs-spinner">
        <svg className="avs-ring" viewBox="0 0 50 50">
          <circle className="avs-ring-track" cx="25" cy="25" r="20" />
          <circle className="avs-ring-fill" cx="25" cy="25" r="20" />
        </svg>
        <div className="avs-lock">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
      </div>

      {/* Text */}
      <p className="avs-msg">{message}</p>
      <p className="avs-sub">{subMessage}</p>
    </div>
  </div>
);

export default AuthVerifyScreen;
